import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ImageSrcAttribute extends AbstractBlock {
  constructor() {
    super('src_att_v2', t.to('ファイルパス', 'image_path'));
  }
  public SRC_FIELD_NAME = 'image_src';
  public SRC_FIELD_NAME_OLD = 'src_att_v2';

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setTitleField(block, this.title);

    const path = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField('').appendField(path, this.SRC_FIELD_NAME); // TODO: 見直し：AbstractBlockで自身の名前でフィールドを1つ作る仕様になっている。
    const pathOld = new Blockly.FieldTextInput('');

    block
      .appendDummyInput()
      .appendField('')
      .appendField(pathOld, this.SRC_FIELD_NAME_OLD)
      .setVisible(false); // TODO: 過去のフィールド
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    let path = CodeSetting.getFieldValue(block, this.SRC_FIELD_NAME);
    if (!path) {
      path = CodeSetting.getFieldValue(block, this.SRC_FIELD_NAME_OLD);
    }
    // let str =  " src =  '"  + path + "' " + attribute ;
    const str = CodeSetting.buildAttribute([['src', path]], attribute);
    return [str];
  }
}
